import { statusFillColor, statusStrokeColor } from '@/components/system/colors.ts'

export interface SvgStockOptions {
  strokeWidth?: number
  strokeLinecap?: 'round' | 'square' | 'butt'
  strokeLinejoin?: 'round' | 'bevel' | 'miter'
  strokeDasharray?: string
}

const svgStock = ({ strokeWidth, strokeLinecap, strokeLinejoin, strokeDasharray }: SvgStockOptions = {}): string =>
  (strokeWidth !== undefined ? `stroke-width="${strokeWidth}" ` : '') +
  (strokeLinecap !== undefined ? `stroke-linecap="${strokeLinecap}" ` : '') +
  (strokeLinejoin !== undefined ? `stroke-linejoin="${strokeLinejoin}" ` : '') +
  (strokeDasharray !== undefined ? `stroke-dasharray="${strokeDasharray}" ` : '')

const vipCarPath = `
<path
  d="M36.5 20.0765C36.5 18.8176 36.1576 17.6465 35.57 16.6467C35.7482 16.393 35.8801 16.1045 35.9541 15.7951C35.9542 15.7947 35.9543 15.7943 35.9544 15.7938L36.4204 13.8483L36.4205 13.8479C36.7736 12.3717 35.7143 10.7895 34.0562 10.7895H32.5728L31.6556 8.39636C30.4424 4.97783 27.4738 1.70459 23.0509 1.70459H14.9491C10.527 1.70459 7.55761 4.97784 6.34368 8.39621L5.42644 10.7895H3.94301C2.28566 10.7895 1.22521 12.3711 1.57961 13.8483C1.57964 13.8484 1.57967 13.8486 1.5797 13.8487C1.57977 13.849 1.57985 13.8493 1.57992 13.8496L2.04563 15.7938C2.04569 15.7941 2.04574 15.7943 2.0458 15.7945C2.04584 15.7947 2.04589 15.7949 2.04593 15.7951C2.11995 16.1045 2.25186 16.3931 2.43014 16.6469C1.84238 17.6466 1.5 18.8177 1.5 20.0765V22.1242C1.5 23.5958 1.97255 24.94 2.74352 26.0334V28.0655C2.74352 30.2661 4.46903 32.1611 6.73057 32.1611H8.33333C10.5949 32.1611 12.3204 30.2661 12.3204 28.0655V26.9698H25.6796V28.0655C25.6796 30.2661 27.4051 32.1611 29.6667 32.1611H31.2694C33.531 32.1611 35.2565 30.2661 35.2565 28.0655V26.0337C36.0277 24.9406 36.5 23.5962 36.5 22.1242V20.0765Z"
  stroke="#FCE96A"
  stroke-width="4"
/>
`

const flagCarPath = `
<path d="M1.5 31.9795V2.80964C1.56211 2.75285 1.64861 2.67835 1.76161 2.591C2.04858 2.36917 2.50757 2.06361 3.17388 1.75457C4.50479 1.13728 6.67615 0.5 9.97602 0.5C13.2777 0.5 16.0311 1.13688 18.8391 1.78806L18.8564 1.79207C21.6529 2.44059 24.5048 3.10197 27.9281 3.10197C31.3602 3.10197 33.6769 2.43827 35.151 1.75457C35.6711 1.51331 36.0847 1.27032 36.4041 1.05464V31.0159C36.342 31.0727 36.2555 31.1472 36.1425 31.2346C35.8555 31.4564 35.3965 31.762 34.7302 32.071C33.3993 32.6883 31.2279 33.3256 27.9281 33.3256C24.6645 33.3256 22.142 32.3696 19.5379 31.3785L19.5145 31.3696C16.9239 30.3837 14.25 29.3661 10.792 29.3661C7.34447 29.3661 4.82119 30.1778 3.15044 31.0014C2.4517 31.3458 1.90346 31.6916 1.5 31.9795ZM1.37646 2.93102C1.37627 2.93123 1.37662 2.93083 1.37752 2.92984L1.37715 2.93024L1.37646 2.93102Z" fill="#31C48D" stroke="#0E9F6E" stroke-linecap="round" stroke-linejoin="round"/>
`

const manualCarPath = `
<circle cx="29.5" cy="6.5" r="6.5" fill="#1F2A37"/>
<path d="M28.718 9.426L27.17 4.386H27.134C27.14 4.506 27.149 4.686 27.161 4.926C27.173 5.166 27.185 5.424 27.197 5.7C27.209 5.97 27.215 6.216 27.215 6.438V9.426H26V3H27.854L29.375 7.914H29.402L31.013 3H32.867V9.426H31.598V6.384C31.598 6.18 31.601 5.946 31.607 5.682C31.619 5.418 31.628 5.169 31.634 4.935C31.646 4.695 31.655 4.515 31.661 4.395H31.625L29.969 9.426H28.718Z" fill="white"/>
`

const electricCarPath = `
<circle cx="29.5" cy="6.5" r="6" fill="white" stroke="#374151"/>
<path d="M32.9564 5.0375C32.8923 4.89863 32.7642 4.8125 32.6251 4.8125H30.1782L30.9726 2.57832C31.019 2.44868 31.0048 2.30094 30.935 2.18492C30.8652 2.06891 30.736 2 30.6251 2H27.875C27.687 2 27.5283 2.15655 27.5034 2.36633L27.0034 6.58508C26.9888 6.70566 27.0215 6.82695 27.0928 6.91836C27.1641 7.00977 27.267 7.0625 27.375 7.0625H29.661L29.0082 10.4744C28.9706 10.6716 29.0624 10.871 29.2269 10.9506C29.275 10.9895 29.325 11 29.375 11C29.4957 11 29.6129 10.9341 29.6846 10.8165L32.9347 5.47273C33.0126 5.34336 33.022 5.17637 32.9564 5.0375Z" fill="#111928"/>
`

const pauseCarPath = `
<circle cx="7.5" cy="28.5" r="6" fill="#D03801" stroke="white"/>
<line x1="7.5" y1="25.5" x2="7.5" y2="28.5" stroke="white" stroke-linecap="round"/>
<line x1="7.707" y1="29.0123" x2="9.79097" y2="31.1704" stroke="white" stroke-linecap="round"/>
`

const returningCarPath = `
<rect x="11" y="23" width="16" height="11" rx="2" fill="black"/>
<path d="M16.7188 32V25.4545H19.1734C19.6762 25.4545 20.0981 25.5419 20.439 25.7166C20.782 25.8913 21.0409 26.1364 21.2156 26.4517C21.3925 26.7649 21.4809 27.1303 21.4809 27.5479C21.4809 27.9677 21.3914 28.332 21.2124 28.641C21.0356 28.9478 20.7746 29.1854 20.4294 29.3537C20.0843 29.5199 19.6602 29.603 19.1574 29.603H17.4092V28.6186H18.9976C19.2916 28.6186 19.5324 28.5781 19.7199 28.4972C19.9074 28.4141 20.0459 28.2937 20.1354 28.136C20.227 27.9762 20.2728 27.7802 20.2728 27.5479C20.2728 27.3157 20.227 27.1175 20.1354 26.9535C20.0438 26.7873 19.9042 26.6616 19.7167 26.5763C19.5292 26.489 19.2874 26.4453 18.9912 26.4453H17.9046V32H16.7188ZM20.1002 29.0341L21.7206 32H20.3975L18.8058 29.0341H20.1002Z" fill="white"/>
`

export type CarMarkerSvgOptions = {
  flagged?: boolean
  vip?: boolean
  manual?: boolean
  electric?: boolean
  paused?: boolean
  returning?: boolean
} & SvgStockOptions

const carSvg = (
  fillColor: string,
  strokeColor: string,
  { flagged, vip, manual, electric, paused, returning, ...stockOptions }: CarMarkerSvgOptions
): string => `
<svg width="38" height="37" viewBox="0 0 38 37" fill="none" xmlns="http://www.w3.org/2000/svg">
  ${flagged ? flagCarPath : ''}
  ${vip ? vipCarPath : ''}
  <g filter="url(#filter0_d_1878_58137)">
    <path
        d="M34.0562 12.2647H31.5413L30.248 8.82353C29.1693 5.70588 26.6315 3 23.0509 3H14.9491C11.3693 3 8.83074 5.70588 7.75121 8.82353L6.45794 12.2647H3.94301C3.33601 12.2647 2.89067 12.8719 3.03834 13.4981L3.50466 15.4834C3.60803 15.9251 3.98109 16.2353 4.40933 16.2353H4.71606C3.67228 17.2056 3 18.616 3 20.2059V22.2941C3 23.6276 3.47876 24.8312 4.24352 25.7626V28.3529C4.24352 29.8146 5.35725 31 6.73057 31H8.33333C9.70665 31 10.8204 29.8146 10.8204 28.3529V25.7059H27.1796V28.3529C27.1796 29.8146 28.2934 31 29.6667 31H31.2694C32.6427 31 33.7565 29.8146 33.7565 28.3529V25.7626C34.5212 24.832 35 23.6284 35 22.2941V20.2059C35 18.616 34.3277 17.2056 33.2847 16.2353H33.5907C34.0189 16.2353 34.392 15.9251 34.4954 15.4834L34.9617 13.4981C35.1086 12.8719 34.6632 12.2647 34.0562 12.2647Z"
        fill="white"
    />
  </g>
  <path
      d="M31.0732 12.4406L31.195 12.7647H31.5413H34.0562C34.3017 12.7647 34.5573 13.0321 34.4749 13.3837C34.4749 13.3838 34.4749 13.3838 34.4749 13.3839L34.0086 15.369L34.0085 15.3694C33.9535 15.6044 33.7673 15.7353 33.5907 15.7353H33.2847H32.0132L32.9441 16.6014C33.8892 17.4805 34.5 18.7598 34.5 20.2059V22.2941C34.5 23.5062 34.0656 24.5989 33.3702 25.4451L33.2565 25.5835V25.7626V28.3529C33.2565 29.5683 32.3377 30.5 31.2694 30.5H29.6667C28.5984 30.5 27.6796 29.5683 27.6796 28.3529V25.7059V25.2059H27.1796H10.8204H10.3204V25.7059V28.3529C10.3204 29.5683 9.40159 30.5 8.33333 30.5H6.73057C5.66231 30.5 4.74352 29.5683 4.74352 28.3529V25.7626V25.5836L4.62996 25.4453C3.93432 24.5981 3.5 23.5053 3.5 22.2941V20.2059C3.5 18.7598 4.11082 17.4806 5.05649 16.6015L5.98829 15.7353H4.71606H4.40933C4.23267 15.7353 4.04649 15.6044 3.99151 15.3694L3.99142 15.369L3.52509 13.3837L3.52499 13.3833C3.44216 13.0321 3.69744 12.7647 3.94301 12.7647H6.45794H6.80418L6.92598 12.4406L8.21925 8.99943L8.21941 8.99949L8.22368 8.98713C9.26232 5.9876 11.6588 3.5 14.9491 3.5H23.0509C26.342 3.5 28.7376 5.98757 29.7755 8.98703L29.7753 8.98708L29.78 8.99943L31.0732 12.4406Z"
      fill="${fillColor}"
      stroke="${strokeColor}"
      ${svgStock(stockOptions)}
  />
  ${manual ? manualCarPath : ''}
  ${electric ? electricCarPath : ''}
  ${paused ? pauseCarPath : ''}
  ${returning ? returningCarPath : ''}
  <defs>
    <filter
      id="filter0_d_1878_58137"
      x="0"
      y="3"
      width="38"
      height="34"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dy="3" />
      <feGaussianBlur stdDeviation="1.5" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.33 0" />
      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1878_58137" />
      <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1878_58137" result="shape" />
    </filter>
  </defs>
</svg>
`

export type CarMarkerOptions = Omit<CarMarkerSvgOptions, 'paused' | 'returning' | 'strokeWidth'>
export const svgCarMarker = (
  status: 'pending' | 'allocated' | 'assigned' | 'onboarded' | 'available' | 'paused' | 'returning' | 'onboardFlagged',
  options: CarMarkerOptions = {}
) => {
  switch (status) {
    case 'pending':
    case 'onboardFlagged':
      return carSvg(statusFillColor(status), statusStrokeColor(status), {
        ...options,
        strokeLinecap: 'square',
        strokeLinejoin: 'bevel',
        strokeDasharray: '2 2',
      })
    case 'assigned':
      return carSvg(statusFillColor(status), statusStrokeColor(status), { ...options, strokeWidth: 2 })
    case 'paused':
      return carSvg(statusFillColor(status), statusStrokeColor(status), { ...options, paused: true })
    case 'returning':
      return carSvg(statusFillColor(status), statusStrokeColor(status), { ...options, returning: true })
    default:
      return carSvg(statusFillColor(status), statusStrokeColor(status), options)
  }
}
